<template>
  <div class="inputLanguage">
    <header class="demo-header mdl-layout__header mdl-color--grey-100 mdl-color-text--grey-600">
      <div class="mdl-layout__header-row">

        <span class="mdl-layout-title">Input Language {{ $route.params.name }}</span>
        <div class="mdl-layout-spacer"></div>

      </div>
    </header>

    <div class="loading-holder" v-if="!language">
      <h3>Loading Data...</h3>
      <div class="mdl-progress mdl-js-progress mdl-progress__indeterminate"></div>
      <h4>Please wait!</h4>
    </div>

    <div class="input-language-card mdl-card mdl-shadow--2dp" v-if="language" v-bind:class="{ blurred: state == 'working' }">
<!--      <div class="mdl-card__supporting-text mdl-card&#45;&#45;expand">
        <pre>{{ JSON.stringify(config, null, 2) }}</pre>
      </div>-->
      <div class="mdl-card__supporting-text mdl-card--expand">

        <div class="translationTarget"
             v-for="inputType in Object.keys(translationTargets)">

          <h4>{{ inputType }}</h4>

          <h6>Columns</h6>
          <ColumnTranslation
            :targets="translationTargets[inputType]"
            v-model="config[inputType].columnTranslation">
          </ColumnTranslation>

          <h6>Summary Lines</h6>
          <SummaryRegex
            v-model="config[inputType].summaryRegex"
          ></SummaryRegex>

        </div>

      </div>

      <div class="mdl-card__supporting-text mdl-card--border">
        <button class="mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect" @click="save">
          <i class="material-icons">save</i>
          Save
        </button>
      </div>

    </div>

  </div>
</template>

<script>
  import api from "api"

  import languageInitialData from "./config/initData.js"
  import ColumnTranslation from "./config/ColumnTranslation.vue"
  import SummaryRegex from "./config/SummaryRegex";

  const translationTargets = {
    adPerformance: Array.from(new Set(languageInitialData.adPerformance.columnTranslation.map(v=>v.to))),
    searchQueryPerformance: Array.from(new Set(languageInitialData.adPerformance.columnTranslation.map(v=>v.to)))
  }

  export default {
    name: "InputLanguage",
    components: {
      SummaryRegex,
      ColumnTranslation
    },
    data() {
      return {
        state: "ready",
        translationTargets,
        config: null
      }
    },
    reactive: {
      language() {
        return ['config', 'inputLanguage', this.$route.params.name ]
      }
    },
    watch: {
      language(v) {
        this.config = v.config
      }
    },
    computed: {

    },
    methods: {
      save() {
        this.state = "working"
        api.request(['config','saveInputLanguage'], this.language.id, this.config).then(
          done => {
            this.deleting = null
            this.state = "ready"
          }
        )
      }
    }
  }
</script>

<style scoped>
  .input-language-card {
    margin: 23px auto auto;
    min-height: 70vh;
    min-width: 91%;
  }

  .loading-holder {
    position: absolute;
    right: 0em;
    left: 0em;
    width: auto;
    top: 0em;
    bottom: 0em;
    height: auto;
    text-align: center;
  }
  .loading-holder .mdl-progress {
    margin-left: auto;
    margin-right: auto;
  }

  .blurred {
    filter: blur(2px);
  }

</style>



// WEBPACK FOOTER //
// InputLanguage.vue?562f458a